<template>
    <div class="box">
        <!--..右侧盒子..-->
        <div class="me_tiwen">
            <div class="tiw_tit">
                <p>我的提问</p>
            </div>
            <div class="me_tiwen_box" v-loading="loading">
                <ul class="wenda" v-if="pageData.length">
                    <li v-for="item in pageData" :key='item.id'>
                        <a :href="'/agricultural/questiondetails?id='+item.id">
                            <div class="wen">
                                <span>问</span>
                                <p>{{item.content}}</p>
                            </div>
                            <div class="da" v-if="item.state != -1">
                                <span>答</span>
                                <p v-if="item.answer_count > 0">{{item.answer_content}}</p>
                                <p v-else>暂无回复</p>
                            </div>
                            <div class="xia" v-if="item.state != -1">
                                <p>全部{{item.answer_count}}条信息</p>
                                <p v-if="item.answer_count > 0">更新于{{ $util.timeStampTurnTime(item.answer_time, 'YYYY-MM-DD') }}</p>
                            </div>
                            <div class="xia" v-else style="justify-content:flex-end;margin-top:26px">
                               <img src="@/assets/styles/images/bohui.png" /> 
                            </div>
                        </a>
                    </li>
                </ul>
                 <!--...分页..-->
                <div class="pages" v-if="pageData.length">
                    <div class="Pagination Pagination_course"></div>
                     <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
                </div>
                <div v-if="!loading && !pageData.length" style="text-align: center;margin-top: 20px;">您还没有提问哦</div>
            </div>
        </div>
    </div>
</template>

<script>

    import '@/assets/styles/css/common.css';
    import '@/assets/styles/css/me.css';
    import '@/assets/styles/js/jquery.pagination.js';
    import { questionMyPage } from '@/api/expert/question';

    export default {
        name: "",
        components: {},
        data: () => {
            return {
                pageCount:0,
                page_size:9,
                page:1,
                pageData:[],
                loading:true,
            }
        },
        created() {
           this.getQuestion();
        },
        methods: {
            getQuestion(){
                questionMyPage({
                    page_size: this.page_size,
                    page: this.page,
                }).then(res => {
                    if(res.code == 0) {
                        this.pageCount = res.data.page_count;
                        console.log(this.pageCount);
                        $(".Pagination").pagination(this.pageCount, {
                            callback: this.changePage
                        });
                        this.pageData = res.data.list;
                        this.loading = false;
                    }
                });
            },
            changePage(page_id) {
                this.loading = true;
                this.page = page_id + 1;
                questionMyPage({
                    page_size: this.page_size,
                    page: this.page,
                }).then(res => {
                    if(res.code == 0) {
                        this.pageData = res.data.list;
                        this.loading = false;
                    }
                });
            },
        },
        mounted() {
            
		},
    }
</script>